<template>
    <div class="text-center">
        <v-dialog v-model="$store.state.isLoading" persistent width="300">
            <v-card color="primary" dark style="padding-top: 15px;">
                <v-card-text>
                    Please stand by
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                        style="margin-top: 8px;"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'LoadingComponent'
};
</script>

<style scoped>
.v-dialog__content--active {
    background-color: rgba(0, 0, 0, 0.7);
}
.v-dialog__content {
    opacity: 0.995;
}
</style>
